<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" width="100" height="100">
        <rect fill="#ffffff" stroke="currentColor" stroke-width="51.01" stroke-linecap="round" stroke-linejoin="round"
            width="1886.7651" height="1868.6666" x="80.617432" y="89.666687" rx="118.02034" ry="118.02034" />
        <path fill="none" stroke="currentColor" stroke-width="52.1783" stroke-linecap="round"
            d="m 991.74691,262.94238 -0.14463,270.75254" />
        <path fill="none" stroke="currentColor" stroke-width="52.1783" stroke-linecap="round"
            d="M 596.44338,814.89384 994.89048,530.1719 1385.1559,813.25751" />
        <path fill="none" stroke="currentColor" stroke-width="52.17834395" stroke-linecap="round"
            d="M 304.86046,1566.6622 H 1082.4911" />
        <path fill="none" stroke="currentColor" stroke-width="52.1783" stroke-linecap="round"
            d="m 673.41017,761.3469 v 796.0588" />
        <path fill="none" stroke="currentColor" stroke-width="52.17834395" stroke-linecap="round"
            d="M 1309.7944,764.92124 V 1142.4305" />
        <path fill="none" stroke="currentColor" stroke-width="52.1783" stroke-linecap="round"
            d="M 293.89378,1049.5659 363.31752,926.91728 H 659.52544" />
        <path fill="none" stroke="currentColor" stroke-width="52.1783" stroke-linecap="round"
            d="M 293.89379,1052.9266 H 666.4678" />
        <path fill="none" stroke="currentColor" stroke-width="52.1783" stroke-linecap="round"
            d="m 358.68927,1066.8114 0,495.2225" />
        <path fill="none" stroke="currentColor" stroke-width="52.1783" stroke-linecap="round"
            d="M 1686.9966,1049.5659 1617.5729,926.91728 H 1321.365" />
        <path fill="none" stroke="currentColor" stroke-width="52.1783" stroke-linecap="round"
            d="m 1686.9966,1052.9266 h -372.574" />
        <path fill="none" stroke="currentColor" stroke-width="49.1394" stroke-linecap="round"
            d="m 1622.2011,1056.9186 v 184.7179" />
        <path fill="currentColor" stroke="currentColor" stroke-width="32.6115" stroke-linecap="round"
            stroke-linejoin="round"
            d="m 1001.7358,286.95142 h 217.5277 l -40.5884,71.99523 40.5884,55.2816 -222.15596,0 z" />
        <circle fill="currentColor" stroke="currentColor" stroke-width="32.6115" stroke-linecap="round"
            stroke-linejoin="round" cx="985.81696" cy="821.51416" r="69.423729" />
        <rect fill="currentColor" width="127.85723" height="134.75159" x="451.25421" y="1140.8633" rx="23.719761"
            ry="37.604465" />
        <rect fill="currentColor" width="127.85723" height="134.75159" x="451.25421" y="1338.1423" rx="23.719761"
            ry="37.604465" />
        <path fill="currentColor"
            d="M990.7983 1014.5265 A 138.27014 138.27014 0 0 0 852.53079 1152.7983 A 138.27014 138.27014 0 0 0 852.59023 1156.8875 L 852.53079 1156.8875 L 852.53079 1574.1529 L 1074.845 1574.1529 A 331.59509 331.59509 0 0 1 1053.7452 1457.758 A 331.59509 331.59509 0 0 1 1129.0701 1247.3291 L 1129.0701 1156.8875 L 1129.0106 1156.8875 A 138.27014 138.27014 0 0 0 1129.0701 1152.7983 A 138.27014 138.27014 0 0 0 990.7983 1014.5265 z" />
        <circle fill="none" stroke="currentColor" stroke-width="52.17834395" stroke-linecap="round"
            stroke-linejoin="round" cx="1385.3424" cy="1457.7581" r="311.91907" />
        <path fill="none" stroke="currentColor" stroke-width="52.17834395" stroke-linecap="square"
            stroke-linejoin="round"
            d="m 1315.0779,1567.4666 c 107.6745,90.3181 233.5161,-61.3034 53.0998,-107.8595 -138.5356,-35.7488 -30.5311,-179.346 66.3747,-107.8593" />
        <path fill="none" stroke="currentColor" stroke-width="52.1783" stroke-linecap="round" stroke-linejoin="round"
            d="m 1381.8832,1629.2966 0,-32.1536" />
        <path fill="none" stroke="currentColor" stroke-width="52.1783" stroke-linecap="round" stroke-linejoin="round"
            d="m 1381.8832,1324.1205 v -32.1536" />
    </svg>
</template>

<style>
svg {
    transition: fill .2s ease, stroke .2s ease;
}
</style>

<script>
export default {
    name: 'aoeIndTuitionLogo',
}
</script>
